export default __webpack_public_path__ + "static/media/impnota.935838c2.webp";